import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import LinearProgress from "@material-ui/core/LinearProgress";
import {mergeSession} from "../firebaseApi"
const styles = (theme) => ({});

function InstructorSessionMerge(props) {
  let mobile = props.width === "sm" || props.width === "xs";
  const [loading, setLoading] = React.useState(false);

  function sessionMerge() {
    setLoading(true);
    //mergeSession({courseID:props.courseID, sessionID:props.sessionID,sessionNum:props.sessionNumber})
    props.mergeSesh(props.courseID,props.sessionID,props.sessionNumber)
    setLoading(false);
    props.openCtl(false);

  }

  return (
    <Dialog
      fullScreen={mobile}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Merge Session " + props.sessionNumber + "?"}</DialogTitle>

      <DialogContent>
        <DialogContentText>
            Merging this session will combine this poll's session with the previous poll's session.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            props.openCtl(false);
          }}
        >
          Cancel
        </Button>

        <Button color="primary" onClick={sessionMerge}>
          Merge
        </Button>
      </DialogActions>
      {loading ? <LinearProgress /> : null}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(styles, { withTheme: true })(withWidth()(InstructorSessionMerge))));
